<app-nav-menu></app-nav-menu>


<p-toast></p-toast>

<main class="main">
  <div class="b2bContainer mainSection">
    <div class="row">
      <div class="col-sm-12" style="width:100%">
        <form action=""
          class="main_form"
          #flightSearchForm="ngForm"
          (ngSubmit)="flightSearchValidation(flightSearchForm)">
          <!-- Tab panes -->

          <div class="main_card">

            <!-- 1st Tab -->
            <div id="searchFlights searchbar"
              class="searchFlights-methods-tabcontent"
              style="display: block">

              <div class="searchtab">

                <span class="search-type-tab active" id="searchFlights-methods-tablinks" [class.active]="selectedMainDiv === 1"
                  (click)="searchFlightsMethod(1)">


                  <svg viewBox="0 0 37 21" fill="orange" xmlns="http://www.w3.org/2000/svg" class="product-icon" style="
    fill: orange !important;
">
                    <path d="M35.2934 1.03321C34.0582 0.582706 32.7434 0.391651 31.4311 0.471969C30.1188 0.552288 28.8371 0.902253 27.6661 1.50003L10.7289 9.83228L6.72037 7.06197C6.07289 6.61491 5.3252 6.33431 4.54346 6.245C3.76172 6.15569 2.97001 6.26044 2.23838 6.54994L0.448242 7.25748L7.44388 12.9364C8.33869 13.6714 9.46755 14.0607 10.6252 14.0337C10.9162 14.0333 11.2049 13.981 11.4777 13.8794L18.4906 11.1782L18.5212 11.1902L19.129 9.58358L26.6207 6.62573L25.6764 8.25761L35.336 4.43261C35.6775 4.29584 35.9697 4.05887 36.174 3.75287C36.3783 3.44688 36.4852 3.08622 36.4806 2.71832C36.476 2.35042 36.3601 1.99254 36.1482 1.69176C35.9363 1.39098 35.6383 1.16139 35.2934 1.03321Z" fill="#E5F5FD"></path>
                    <path d="M2.23838 8.05056C2.97001 7.76106 3.76172 7.65634 4.54346 7.74565C5.3252 7.83496 6.07289 8.11554 6.72038 8.56259L10.2754 11.0204C10.4128 11.1156 10.5732 11.1724 10.7399 11.1848C10.9066 11.1972 11.0737 11.1647 11.2236 11.0909L18.2313 7.64093L22.8928 5.34541L27.6634 2.99668C28.8344 2.3989 30.1161 2.04894 31.4284 1.96862C32.7408 1.8883 34.0556 2.07935 35.2908 2.52986C35.5208 2.61062 35.7318 2.73776 35.9107 2.90339C36.0896 3.06902 36.2326 3.26961 36.3308 3.49276C36.4352 3.256 36.4891 3.00008 36.4891 2.74132C36.4933 2.36659 36.3801 1.99994 36.1655 1.69275C35.9508 1.38555 35.6454 1.15322 35.2921 1.02833C34.0569 0.577823 32.7421 0.386768 31.4298 0.467087C30.1174 0.547405 28.8358 0.897371 27.6647 1.49515L22.8941 3.84388L18.2326 6.1394L10.7302 9.83272L6.7217 7.0624C6.07422 6.61535 5.32654 6.33475 4.54479 6.24544C3.76305 6.15613 2.97134 6.26087 2.23971 6.55037L0.448242 7.25791L1.69176 8.26736L2.23838 8.05056Z" fill="#B9C8DB"></path>
                    <path d="M22.8933 3.84314L18.2318 6.13866L11.9424 2.08625L14.2645 0.673828L22.8933 3.84314Z" fill="#43CAF9"></path>
                    <path d="M20.9343 4.78695L12.993 1.41016L11.9424 2.08577L18.2318 6.13819L20.9343 4.78695Z" fill="#29C2F8"></path>
                    <path d="M20.0341 5.23765L12.6195 1.63477L11.9438 2.08561L18.2333 6.13804L20.0341 5.23765Z" fill="#00B8F8"></path>
                    <path d="M26.6216 6.62695L25.6773 8.25883L19.0488 19.7059H15.3022L18.5221 11.1941L19.1299 9.58746L26.6216 6.62695Z" fill="#43CAF9"></path>
                    <path d="M21.9833 8.53418L19.2808 9.58485L18.673 11.1915L15.4531 19.7033H16.8802L21.9833 8.53418Z" fill="#29C2F8"></path>
                    <path d="M20.632 9.05957L19.2808 9.59155L18.673 11.1982L15.4531 19.71H16.1288L20.632 9.05957Z" fill="#00B8F8"></path>
                    <path d="M35.4436 0.603739C34.1511 0.134217 32.776 -0.0649618 31.4034 0.0185389C30.0308 0.10204 28.6899 0.466439 27.4638 1.08917L22.8675 3.35012L14.4195 0.2473C14.3558 0.22392 14.2877 0.215253 14.2202 0.221933C14.1527 0.228612 14.0876 0.250473 14.0298 0.285878L11.7077 1.6983C11.6425 1.73798 11.5885 1.79354 11.5507 1.85979C11.5129 1.92603 11.4925 2.00079 11.4914 2.07706C11.4904 2.15333 11.5087 2.22863 11.5446 2.2959C11.5806 2.36317 11.633 2.42022 11.697 2.4617L17.3162 6.0832L10.7687 9.30971L6.97831 6.68967C6.27068 6.19946 5.45288 5.89171 4.59762 5.7938C3.74237 5.69588 2.87617 5.81083 2.07605 6.12843L0.284582 6.8373C0.211509 6.86629 0.147287 6.91389 0.0982883 6.97537C0.0492893 7.03684 0.0172158 7.11006 0.00525174 7.18776C-0.00671232 7.26546 0.0018482 7.34494 0.0300836 7.41831C0.0583191 7.49168 0.105249 7.55639 0.166215 7.60602L7.16185 13.285C8.10032 14.0531 9.27407 14.4756 10.4868 14.482H10.6384C10.9805 14.4799 11.3196 14.4173 11.6399 14.2971L17.7577 11.9417L14.8837 19.5425C14.8578 19.6107 14.8489 19.6842 14.8578 19.7566C14.8666 19.8291 14.8929 19.8983 14.9343 19.9583C14.9758 20.0183 15.0312 20.0674 15.0958 20.1013C15.1604 20.1352 15.2323 20.1529 15.3053 20.1529H19.0518C19.1307 20.1529 19.2083 20.1321 19.2766 20.0926C19.345 20.0532 19.4019 19.9965 19.4415 19.9282L25.9915 8.6168L35.5048 4.85033C35.9335 4.68071 36.3005 4.38472 36.5571 4.00165C36.8137 3.61857 36.9477 3.16653 36.9413 2.70552C36.935 2.24451 36.7886 1.79632 36.5216 1.42046C36.2545 1.0446 35.8795 0.758829 35.4463 0.60108L35.4436 0.603739ZM12.7903 2.09463L14.3118 1.16365L21.7503 3.89674L18.2604 5.61506L12.7903 2.09463ZM18.7884 19.2512H15.9556L19.4814 9.92682L25.5846 7.51691L18.7884 19.2512ZM35.171 4.01111L26.7164 7.35864L27.0116 6.84927C27.0585 6.76825 27.079 6.67465 27.0702 6.58147C27.0615 6.48828 27.024 6.40012 26.9629 6.32922C26.9018 6.25833 26.8201 6.20821 26.7292 6.18581C26.6384 6.16341 26.5428 6.16985 26.4557 6.20424L18.964 9.1621C18.9051 9.18593 18.8519 9.22194 18.8079 9.26778C18.7639 9.31363 18.7301 9.36826 18.7086 9.42808L18.1767 10.8179L11.306 13.4645C11.0816 13.547 10.8443 13.5889 10.6051 13.5882C9.55509 13.6123 8.53134 13.2583 7.72044 12.5907L1.32595 7.39189L2.40056 6.9663C3.063 6.70321 3.7802 6.60792 4.48835 6.6889C5.19651 6.76988 5.87368 7.02462 6.45963 7.43046L10.4682 10.2008C10.5342 10.2463 10.6111 10.2733 10.6911 10.2792C10.771 10.285 10.8511 10.2694 10.923 10.234L27.8628 1.89381C28.9792 1.32579 30.2004 0.993146 31.4507 0.916505C32.701 0.839865 33.9537 1.02087 35.1311 1.44827C35.3921 1.54394 35.6179 1.71659 35.7786 1.94341C35.9393 2.17022 36.0274 2.4405 36.0312 2.71846C36.0349 2.99642 35.9542 3.26896 35.7996 3.50003C35.6451 3.73109 35.424 3.90977 35.1657 4.01244L35.171 4.01111Z" fill="#1C3C6B"></path>
                  </svg>

                  <span class="product1">
                    Offline Search
                  </span>
                </span>








              </div>
              @if ( isReissue && !flightsearchshow) {
                <div id="oneWayDiv ant-row">
                  <div style="padding:10px;display:flex;justify-content:center;align-items:center">
                    <div style="font-size:20px;color:#ffaa00;font-weight:bold;letter-spacing:3px">
                      Offline Reissue
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-md-4  mb-2 p-0 pl-2" style="position: relative;">
                      <label for="previousTicketNo" [ngClass]=" !offlinereissueSearch.previousTicketNo?'labelofmodifyserachinputsErrorNew':'labelofmodifyserachinputsNew'">Previous Ticket No</label>
                      <input class="inputStyle reissueField"
                        [(ngModel)]="offlinereissueSearch.previousTicketNo"
                        name="previousTicketNo"
                        #previousTicketNo="ngModel" [ngClass]="{'invalid-Error':  !offlinereissueSearch.previousTicketNo}"
                        id="previousTicketNo"
                        autocomplete="off"
                        required />
                        @if (previousTicketNo.invalid && previousTicketNo.touched) {
                          <small class="text-danger">
                            Previous TicketNo is required
                          </small>
                        }
                      </div>
                      <div class="col-md-4  mb-2 p-0 pl-2" style="position: relative;">
                        <label for="pnr" [ngClass]=" !offlinereissueSearch.pnr?'labelofmodifyserachinputsErrorNew':'labelofmodifyserachinputsNew'">PNR</label>
                        <input class="inputStyle reissueField" (input)="offlinereissueSearch.pnr = offlinereissueSearch.pnr.toUpperCase()"
                          [(ngModel)]="offlinereissueSearch.pnr"
                          name="pnr"
                          #pnr="ngModel" [ngClass]="{'invalid-Error':  !offlinereissueSearch.pnr}"
                          id="pnr"
                          autocomplete="off"
                          required />
                          @if (pnr.invalid && pnr.touched) {
                            <small class="text-danger">
                              PNR is required
                            </small>
                          }
                        </div>
                        <div class="col-md-4  mb-2 p-0 pl-2" style="position: relative;">
                          <span [ngClass]="submitFlightSearch && !searchObj.returnDateFront ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                            Old Departure Date
                          </span>
                          <i class="fas fa-calendar-alt modifySearchCalenderIcon"></i>
                            <p-datepicker [(ngModel)]="offlinereissueSearch.departureDate" #returnDateId="ngModel"
                              name="departureDate" [readonlyInput]="true" class="modifySearchCalender"
                              [numberOfMonths]="monthsToShow" dateFormat="dd M yy" required>
                            </p-datepicker>
                          @if (returnDateId.invalid && returnDateId.touched) {
                            <div>
                              <div style="width: 100%; height: 20px; display: flex; justify-content: start; align-items: center;">
                                <span class="error_class">** Departure Date Required!</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="row m-0">
                        <div class="col-lg-12 col-md-12 col-sm-12  p-0 justify-content-end" style="display:flex">
                          <button class="button btnsmalscreen" style="width:12%"
                            type="submit" (click)="offlineReissueNext()">
                            Next Step
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                  @if (selectedMainDiv === 1 && flightsearchshow) {
                    <div id="oneWayDiv ant-row" >
                      <div class="ant-col ant-col-24">
                        <div class="ant-row ant-row-middle">
                          <div class="flight-type-wrapper menu">
                            <label class="radio" (click)="showtoggleflighttypeDiv(1)" id="onetriptypeclick">
                              <input type="radio" [checked]="selectedDiv === 1" name="flight-type" value="One Way">
                              <span class="radio-btn"></span>
                              <span class="flight-type-text">One Way</span>
                            </label>
                            <label class="radio" (click)="showtoggleflighttypeDiv(2)" id="roundtriptypeclick1">
                              <input type="radio" [checked]="selectedDiv === 2" name="flight-type" value="Round Trip">
                              <span class="radio-btn"></span>
                              <span class="flight-type-text">Round Trip</span>
                            </label>
                            <label class="radio" (click)="showtoggleflighttypeDiv(3)" id="multitriptypeclick">
                              <input type="radio" [checked]="selectedDiv === 3" name="flight-type" value="Multi City">
                              <span class="radio-btn"></span>
                              <span class="flight-type-text">Multi City</span>
                            </label>
                          </div>
                          <div class="customn_column addflightbtn menu"
                            id="addflightbtn">
                            <div class="">
                              <div class="justify-content-between">
                                @if (selectedDiv === 3) {
                                  <div class="grid">
                                    <button class="btn btn-md btndesigntriptypemodify1"
                                      style="color: white"
                                      (click)="AddNewFlight()" type="button">
                                      @if (!idAssigned) {
                                        <i class="fa fa-plus-circle">
                                          Add Flight
                                        </i>
                                      }
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--Round trip Div-->
                      <div>
                        <div class="">
                          @for (flights of searchObj.flightLocationInfo; track flights; let f = $index) {
                            <div class="row  m-0" style="position: relative;">
                              <!--<div *ngIf="selectedDiv === 3">
                              <div class="col-12 modifySearchFligthHeading">Flight {{ f + 1 }}</div>
                            </div>-->
                            <!-- From Airport Section -->
                            <div [ngClass]="selectedDiv === 3? 'col-xl-4 col-md-4 col-sm-12  d-flex flex-column':'col-xl-3  col-md-6 col-sm-12 mb-4 d-flex flex-column'" style="position:relative;">
                              <i class="fas fa-location-dot modifySearchAirportDisplyUpperIcon"></i>
                              <span [ngClass]="submitFlightSearch && !flights.fromAirport ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">From</span>
                              @if (flights.fromAirport) {
                                <div>
                                  <div [ngClass]="selectedDiv === 3? 'modifySearchAirportDisplyDivMulti':'modifySearchAirportDisplyDiv'" (click)="ClickSearchFromAirport(f)">
                                    <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMulti':'modifySearchAirportDisplyUpper'">
                                      <span>{{flights.fromAirport.split('-')[1]}}</span>
                                    </div>
                                    <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMultiLower':'modifySearchAirportDisplyLower'">
                                      {{flights.fromAirport.split('-')[2]}} ({{flights.fromAirport.split('-')[0]}})
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (!flights.fromAirport) {
                                <div>
                                  <p-autoComplete #focusable1 [showEmptyMessage]="true" [(ngModel)]="flights.fromAirport"
                                    [suggestions]="filteredAirportsOW" (completeMethod)="filterAirportsOW($event)"
                                    [forceSelection]="true" [minLength]="2" name="fromAirport{{f}}"
                                    [required]="true"
                                    (blur)="validateAirports()"
                                    (onSelect)="SearchFlightFromCity(flights.fromAirport, f)"
                                    [ngClass]="selectedDiv === 3? ' modifySearchAutoCompMulti ' : 'modifySearchAutoComp'">
                                    <ng-template let-filteredAirports pTemplate="item">
                                      <div class="modifySearchAirports">
                                        <div class="modifySearchAirportsInner">
                                          <span class="modifySearchCityName">{{filteredAirports.split('-')[1]}}</span>
                                          <span class="modifySearchAirportName">{{filteredAirports.split('-')[2]}}</span>
                                        </div>
                                        <div class="modifySearchAirportsIataDiv">
                                          <span class="modifySearchAirportsIATA">{{filteredAirports.split('-')[0]}}</span>
                                        </div>
                                      </div>
                                    </ng-template>
                                  </p-autoComplete>
                                </div>
                              }
                              @if (submitFlightSearch && !flights.fromAirport) {
                                <span class="error_class">
                                  **Flying From Required!
                                </span>
                              }
                            </div>
                            <!-- Double Arrow -->
                            <div [class]="selectedDiv === 3 ? 'modifySearchDoubleArrowMulticity' : 'modifySearchDoubleArrow'">
                              <i class="fas fa-exchange-alt" (click)="InvertSearchFromTo(f)"></i>
                            </div>
                            <!-- To Airport Section -->
                            <div [ngClass]="selectedDiv === 3?'col-xl-4 col-md-4 col-sm-12  d-flex flex-column':'col-xl-3 col-md-6 col-sm-12 mb-4 d-flex flex-column'" style="position:relative;">
                              <i class="fas fa-location-dot modifySearchAirportDisplyUpperIcon"></i>
                        <span [ngClass]="submitFlightSearch && !flights.toAirport
  ? 'labelofmodifyserachinputs'
  : submitFlightSearch && flights.toAirport && flights.fromAirport && flights.toAirport === flights.fromAirport
  ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                                To
                              </span>
                              @if (flights.toAirport) {
                                <div>
                                  <div [ngClass]="selectedDiv === 3? 'modifySearchAirportDisplyDivMulti':'modifySearchAirportDisplyDiv'" (click)="ClickSearchToAirport(f)">
                                    <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMulti':'modifySearchAirportDisplyUpper'">
                                      <span>{{flights.toAirport.split('-')[1]}}</span>
                                    </div>
                                    <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMultiLower':'modifySearchAirportDisplyLower'">
                                      {{flights.toAirport.split('-')[2]}} ({{flights.toAirport.split('-')[0]}})
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (!flights.toAirport) {
                                <div>
                                  <p-autoComplete #focusable [showEmptyMessage]="true" [suggestions]="filteredAirportsOW"
                                    (completeMethod)="filterAirportsOW($event)" [forceSelection]="true" [multiple]="false"
                                    [minLength]="2" name="toAirport{{f}}" [required]="true"
                                    [(ngModel)]="flights.toAirport"
                                    (blur)="validateAirports()"
                                    (onSelect)="SearchFlightToCity(flights.toAirport, f)"
                                    [ngClass]="selectedDiv === 3 ? ' modifySearchAutoCompMulti ' : 'modifySearchAutoComp'">
                                    <ng-template let-filteredAirports pTemplate="item">
                                      <div class="modifySearchAirports">
                                        <div class="modifySearchAirportsInner">
                                          <span class="modifySearchCityName">{{filteredAirports.split('-')[1]}}</span>
                                          <span class="modifySearchAirportName">{{filteredAirports.split('-')[2]}}</span>
                                        </div>
                                        <div class="modifySearchAirportsIataDiv">
                                          <span class="modifySearchAirportsIATA">{{filteredAirports.split('-')[0]}}</span>
                                        </div>
                                      </div>
                                    </ng-template>
                                  </p-autoComplete>
                                </div>
                              }
                              @if (submitFlightSearch && !flights.toAirport ) {
                                <span class="error_class">
                                  **Flying To Required!
                                </span>
                              }
                              @if (submitFlightSearch && flights.toAirport !=''&& flights.fromAirport !='' && flights.toAirport.split('-')[0] == flights.fromAirport.split('-')[0]) {
                                <span class="error_class">
                                  **From & To Should not Same!
                                </span>
                              }
                            </div>
                            <div [ngClass]="selectedDiv != 3 ? 'col-xl-2 col-md-4 mb-lg-4 mb-4 d-flex flex-column' : 'col-xl-3 col-md-3 col-sm-12 mb-lg-4 mb-4 d-flex flex-column'" style="position:relative;">
                              <span [ngClass]="submitFlightSearch && !flights.departureDateFront ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                                Departure Date
                              </span>
                              <i class="fas fa-calendar-alt modifySearchCalenderIcon"></i>
                              <p-datepicker [(ngModel)]="flights.departureDateFront" #departureDateId [minDate]="currentDateDepartureList[f]" (ngModelChange)="SetReturnMinDate(flights.departureDateFront!)"
                                name="departureDate{{f}}" [readonlyInput]="true"
                                [ngClass]="submitFlightSearch && !flights.departureDateFront ? 'modifySearchCalender modifySearchDepartureCalender' : 'modifySearchCalender modifySearchDepartureCalender'"
                                panelStyleClass="modifySearchDepartureCalenderPanel"
                                [numberOfMonths]="monthsToShow"
                                dateFormat="dd M yy"
                                required>
                              </p-datepicker>
                              @if (!flights.departureDateFront && submitFlightSearch) {
                                <div>
                                  <div style="width: 100%; height: 20px; display: flex; justify-content: start; align-items: center;">
                                    <span class="error_class">** Departure Date Required!</span>
                                  </div>
                                </div>
                              }
                            </div>
                            @if (selectedDiv ===1 || selectedDiv === 2) {
                              <div class="col-xl-2 col-md-4 col-sm-12 d-flex flex-column daysFieldsm" style="position:relative;">
                                <span style="left:1.9rem" [ngClass]="submitFlightSearch && !searchObj.days ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                                  Days
                                </span>
                                <input [(ngModel)]="searchObj.days" (blur)="addDaysReturn()"
                                  [disabled]="selectedDiv ===1 || selectedDiv === 3" [ngClass]="(submitFlightSearch && !searchObj.days && selectedDiv === 2) ? 'modifySearchDays' : 'modifySearchDays'"
                                  name="datereturndays{{f}}" type="number" />
                                </div>
                              }
                              @if (selectedDiv ===1 || selectedDiv === 2) {
                                <div class="col-xl-2 col-md-4 col-sm-12 mb-lg-4 mb-4 d-flex flex-column" style="position:relative;">
                                  <span [ngClass]="submitFlightSearch && !searchObj.returnDateFront ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                                    Return Date
                                  </span>
                                  <i class="fas fa-calendar-alt modifySearchCalenderIcon"></i>
                                  <p-datepicker [(ngModel)]="searchObj.returnDateFront" #returnDateId [minDate]="currentDateReturn"
                                    name="returnDate{{f}}" [readonlyInput]="true"
                                    [disabled]="selectedDiv ===1 || selectedDiv === 3"
                                    [ngClass]="(submitFlightSearch && !searchObj.returnDateFront && selectedDiv === 2) ? 'modifySearchCalender modifySearchReturnCalender': 'modifySearchCalender modifySearchReturnCalender'"
                                    panelStyleClass="modifySearchReturnCalenderPanel"
                                    [numberOfMonths]="monthsToShow" (ngModelChange)="returndatechange()" dateFormat="dd M yy" required>
                                  </p-datepicker>
                                  @if (!searchObj.returnDateFront && submitFlightSearch && selectedDiv === 2) {
                                    <div>
                                      <div style="width: 100%; height: 20px; display: flex; justify-content: start; align-items: center;">
                                        <span class="error_class">** Return Date Required!</span>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                              @if (selectedDiv === 3 && f > 1) {
                                <div class="removeBtn col-xl-1 col-md-1  d-flex flex-column">
                                  <a class="add_flight"
                                    id="add_flight"
                                    (click)="RemoveFlight(f)">
                                    <i style="font-size: 1.2rem"
                                      class="uil uil-minus">
                                    </i>
                                  </a>
                                </div>
                              }
                            </div>
                          }
                          <div class="row sectionTwo">
                            <div class="col-lg-2 col-md-4 col-sm-4 SectionTwoInner"
                              style="padding: 0 8px 0 0">
                              <div class="form-group">
                                <div class="p-float-label"
                                  style="width: 100% !important">
                                  <p-select class="modifyradiusdays"
                                    [options]="adultList"
                                    optionLabel="adultItem"
                                    optionValue="adultItem"
                                    multiple="true"
                                    [(ngModel)]="searchObj.adult"
                                    name="adult"
                                    (onChange)="changeAdult()"
                                    inputId="float-labels">
                                  </p-select>
                                  <label for="float-labels">Adult</label>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-4 col-sm-4 SectionTwoInner"
                              style="position:relative; padding: 0 8px 0 0">
                              <span class="labelofserachinputs">
                                Child
                              </span>
                              <!--<i class="fas fa-person-icon modifySearchCalenderIcon"></i>-->
                              <p-select #dropdown class="modifySearch_dropPassenger" [options]="passengerSelectionList" [placeholder]="selectedChild || '0'" [filter]="false"
                                [showClear]="false">
                                <ng-template let-selectedItem pTemplate="selectedItem">
                                  <span>{{ selectedChild ? selectedChild : '0' }}</span>
                                </ng-template>
                                <ng-template let-item pTemplate="item">
                                  <div class="dropdownPassengerItem">
                                    <div class="dropdownPassengerItemLabelDiv">
                                      <span class="dropdownPassengerItemLabel">{{ item.label }}</span>
                                      <span class="dropdownPassengerItemLabelText">{{ item.labelText }}</span>
                                    </div>
                                    <div class="dropdownPassengerItemControls">
                                      <i class="fas fa-minus passengerItemControlsButton" (click)="DecrementPax(item); $event.stopPropagation()"></i>
                                      <span class="passengerItemControlsValue">{{ item.value }}</span>
                                      <i class="fas fa-plus passengerItemControlsButton" (click)="IncrementPax(item); $event.stopPropagation()"></i>
                                    </div>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                  <!--<div class="passengerItemAgesHeading text-center text-decoration-underline">
                                  Total 9 Passengers are Allowed
                                </div>-->
                                @if (searchObj.childAges.length > 0) {
                                  <div>
                                    <div class="passengerItemAgesHeading">Child Ages</div>
                                    <div class="passengerItemAgesMain" (click)=" $event.stopPropagation()">
                                      <div class="passengerItemAgesDiv">
                                        @for (chd of searchObj.childAges; track chd; let c = $index) {
                                          <div class="passengerItemAges">
                                            <span class="passengerItemAgesLabel">Child {{c+1}}'s Age</span>
                                            <p-select class="modifySearch_dropAges" name="childAges{{c}}" [options]="childAgeList"
                                              [filter]="false" [showClear]="false" optionLabel="childAgeItem" optionValue="childAgeItem"
                                              [(ngModel)]="searchObj.childAges[c]">
                                            </p-select>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div class="dropdownPassengerItemFooter">
                                  <button type="button" class="btnsmalscreen" (click)="ClosePaxDropdown()">Done</button>
                                </div>
                              </ng-template>
                            </p-select>
                          </div>
                          <div class="col-lg-2 col-md-4 col-sm-4 SectionTwoInner"
                            style="position:relative; padding: 0 8px 0 0">
                            <span class="labelofserachinputs">
                              Infant
                            </span>
                            <p-select #dropdown class="modifySearch_dropPassenger" [options]="passengerSelectionListInfant" [placeholder]="selectedInfant || '0'" [filter]="false"
                              [showClear]="false">
                              <ng-template let-selectedItem pTemplate="selectedItem">
                                <span>{{ selectedInfant ? selectedInfant : '0' }}</span>
                              </ng-template>
                              <ng-template let-item pTemplate="item">
                                <div class="dropdownPassengerItem">
                                  <div class="dropdownPassengerItemLabelDiv">
                                    <span class="dropdownPassengerItemLabel">{{ item.labelInf }}</span>
                                    <span class="dropdownPassengerItemLabelText">{{ item.labelTextInf }}</span>
                                  </div>
                                  <div class="dropdownPassengerItemControls">
                                    <i class="fas fa-minus passengerItemControlsButton" (click)="DecrementPaxInf(item); $event.stopPropagation()"></i>
                                    <span class="passengerItemControlsValue">{{ item.valueInf }}</span>
                                    <i class="fas fa-plus passengerItemControlsButton" (click)="IncrementPaxInf(item); $event.stopPropagation()"></i>
                                  </div>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="footer">
                                <!--<div class="passengerItemAgesHeading text-center text-decoration-underline">
                                Total 9 Passengers are Allowed
                              </div>-->
                              @if (searchObj.infantAges.length > 0) {
                                <div>
                                  <div class="passengerItemAgesHeading">Infant Ages</div>
                                  <div class="passengerItemAgesMain" (click)=" $event.stopPropagation()">
                                    <div class="passengerItemAgesDiv">
                                      @for (chd of searchObj.infantAges; track chd; let c = $index) {
                                        <div class="passengerItemAges">
                                          <span class="passengerItemAgesLabel">Infant {{c+1}}'s Age</span>
                                          <p-select class="modifySearch_dropAges" name="infantAges{{c}}" [options]="infantAgeList"
                                            [filter]="false" [showClear]="false" optionLabel="infantAgeItem" optionValue="infantAgeItem"
                                            [(ngModel)]="searchObj.infantAges[c]">
                                          </p-select>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              }
                              <div class="dropdownPassengerItemFooter">
                                <button type="button" class="btnsmalscreen" (click)="ClosePaxDropdown()">Done</button>
                              </div>
                            </ng-template>
                          </p-select>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 SectionTwoInner1"
                          style="padding: 0 8px 0 0">
                          <div class="form-group">
                            <div class="p-float-label"
                              style="width: 100% !important">
                              <p-select class="modifyradiusdays"
                                [options]="cabinClassList"
                                multiple="true"
                                name="cabinClass"
                                optionLabel="cabinItem"
                                optionValue="cabinItem"
                                [(ngModel)]="searchObj.cabinClass"
                                inputId="float-labels">
                              </p-select>
                              <label for="float-labels">Travel Class</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 SectionTwoInner1"
                          style="padding: 0 8px 0 0">
                          <div class="form-group">
                            <div class="p-float-label"
                              style="width: 100% !important">
                              <p-select class="modifyradiusdays"
                                [options]="fareTypeList"
                                multiple="true"
                                optionLabel="fareItem"
                                optionValue="fareItem"
                                [(ngModel)]="searchObj.fareType"
                                name="fareType"
                                inputId="float-labels">
                              </p-select>
                              <label for="float-labels">Fare Type</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="display:flex; flex-direction:column;">
                      <!-- Button to toggle visibility -->
                      <div class="col-xl-12 col-md-12 col-sm-12" style=" display: flex; text-align: end; width: 99.2%; justify-content: end;">
                        <a (click)="toggleSectionVisibility()" style="text-decoration: underline; color:#ffaa00; cursor:pointer;">
                          {{ isSectionVisible ? 'Hide Search' : 'Advance Search' }}
                        </a>
                      </div>
                      <!-- The section to be hidden/shown with flex layout and animation -->
                      <div [@sectionAnimation]="isSectionVisible ? 'visible' : 'hidden'" class="row sectionThree">
                        <div class="col-xl-2 col-md-3 col-sm-6 SectionTwoInner1">
                          <div>
                            <input type="checkbox" name="cbNonstop" [(ngModel)]="searchObj.nonStopFlight" />
                            <label class="inner_lable">Non-stop flights</label>
                          </div>
                        </div>
                        <div class="col-xl-2 col-md-3 col-sm-6 SectionTwoInner1">
                          <div>
                            <input type="checkbox" name="cbNearAirport" [(ngModel)]="searchObj.nearByAirport" />
                            <label class="inner_lable">Nearby Airports</label>
                          </div>
                        </div>
                        <div class="col-xl-2 col-md-3 col-sm-6 SectionTwoInner1">
                          <div>
                            <input type="checkbox" name="lowCostAirline" [(ngModel)]="searchObj.lowCostAirline" />
                            <label class="inner_lable">Low Cost Airlines</label>
                          </div>
                        </div>
                        <div class="col-xl-2 col-md-3 col-sm-6 SectionTwoInner1">
                          <div>
                            <input type="checkbox" name="gdsAirline" [(ngModel)]="searchObj.gdsAirline" />
                            <label class="inner_lable">GDS Airlines</label>
                          </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="p-float-label" style="width: 100% !important; top:8px;">
                              <p-multiSelect [options]="airlineList$"
                                [(ngModel)]="preferedAirlines"
                                [style]="{ width: '100%' }"
                                [filter]="true"
                                placeholder="From"
                                optionLabel="airlineName"
                                optionValue="airlineCombineCode"
                                [ngModelOptions]="{standalone: true}"
                                [panelStyle]="{ 'width': '1em' }"
                                panelHideOnClickOutside="false"
                                [selectionLimit]="3">
                              </p-multiSelect>
                              <label for="float-labels">Select Airline</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row customn_row searchHistorymain">
                      <div class="col-lg-3 col-md-5 col-sm-5 searchSection">
                      </div>
                      <div class="col-lg-6 col-md-2 col-sm-2 pt-2"></div>
                      <div class="col-lg-3 col-md-5 col-sm-5 searchbtnSection">
                        <button class="button btnsmalscreen"
                          type="submit">
                          <i class="fas fa-search" style="font-size: 14px"></i>&nbsp; Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            <!--</div>-->
          </div>
        </div>


      </form>
    </div>
  </div>
</div>

</main>


